'use client';

import { useEffect, useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap/all';
import { Container, Image, Text, useResizeObserver } from '@weareconceptstudio/core';

//* Styles
import MostWantedSkeletonStyle from './style';

const MostWantedSkeleton = () => {
	//! Refs
	const leftBarRef = useRef();
	const rightBarRef = useRef();
	const innerRightBarRef = useRef();
	const innerWrapperLeftBar = useRef();
	const contentRightRef = useRef();
	const contentWrapperRef = useRef();

	//! Resizes
	const resizes = useResizeObserver(typeof document !== 'undefined' ? document.querySelector('body') : null);

	//! calculate left-right bar height
	useEffect(() => {
		const matchMedia = gsap.matchMedia();

		if (
			rightBarRef.current &&
			document.querySelector('.most-wanted-skeleton-wrapper') &&
			leftBarRef.current &&
			innerRightBarRef.current &&
			innerWrapperLeftBar.current
		) {
			matchMedia.add('(min-width: 1280px)', () => {
				if (innerRightBarRef.current && innerRightBarRef.current) {
					const variableValueGap = getComputedStyle(document.querySelector('.most-wanted-skeleton-wrapper'))
						.getPropertyValue('--gapDistance')
						.trim();
					const itemHeight = innerRightBarRef.current
						? innerRightBarRef.current.children[0].clientHeight
						: null;
					if (leftBarRef.current) {
						leftBarRef.current.style.height = `calc(${rightBarRef.current.clientHeight - 2}px)`;
					}
					innerRightBarRef.current.style.height = `calc(${itemHeight * 2}px + ${variableValueGap})`;
					innerWrapperLeftBar.current.style.height = `calc(${itemHeight * 2}px + ${variableValueGap})`;

					const headerHeight = document.querySelector('header');

					ScrollTrigger.create({
						start: `top-=${headerHeight.clientHeight} top`,
						end: `bottom-=${innerWrapperLeftBar.current.clientHeight + headerHeight.clientHeight}px top`,
						trigger: contentWrapperRef.current,
						pin: leftBarRef.current,
						// markers: true,
						pinSpacing: false,
						id: 'left-bar',
					});

					ScrollTrigger.create({
						start: `top-=${headerHeight.clientHeight} top`,
						end: `bottom-=${innerWrapperLeftBar.current.clientHeight + headerHeight.clientHeight}px top`,
						trigger: contentWrapperRef.current,
						pin: rightBarRef.current,
						// markers: true,
						pinSpacing: false,
						id: 'right-bar',
						onUpdate: (self) => {
							const progress = self.progress;
							if (innerRightBarRef.current) {
								gsap.to(innerRightBarRef.current, {
									duration: 0,
									y:
										(leftBarRef.current.clientHeight - innerWrapperLeftBar.current.clientHeight) *
										-progress,
								});
							}
						},
					});
				}
			});
		}

		return () => {
			if (rightBarRef.current && ScrollTrigger.getById('left-bar')) {
				ScrollTrigger.getById('left-bar').kill();
				ScrollTrigger.getById('right-bar').kill();
				matchMedia.revert();

				leftBarRef.current.style.height = `auto`;
				innerRightBarRef.current.style.height = `auto`;
				innerWrapperLeftBar.current.style.height = `auto`;
			}
		};
	}, [resizes]);

	return (
		<MostWantedSkeletonStyle className='most-wanted-skeleton-wrapper'>
			<Container isSection>
				<div className='title-section'>
					<Text
						className='uppercase h2'
						tag={'h2'}
						text={'mostWanted'}
					/>
				</div>

				<div
					ref={contentWrapperRef}
					className='inner-wrapper'>
					<div ref={leftBarRef}>
						<div ref={innerWrapperLeftBar}>
							<Image
								src={'/images/most-wanted-sceleton.svg'}
								alt={'skeleton'}
								className={'item-product-skeleton'}
							/>
						</div>
					</div>
					<div
						ref={rightBarRef}
						className='right-bar'>
						<div
							ref={contentRightRef}
							className='inner-wrapper-right-bar'>
							<div
								ref={innerRightBarRef}
								className='content-right-bar'>
								{Array.from({ length: 12 }).map((_, i) => {
									return (
										<Image
											key={i}
											src={'/images/product-min.svg'}
											alt={'skeleton'}
											className={`item-product item-product-skeleton`}
										/>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</Container>
		</MostWantedSkeletonStyle>
	);
};

export default MostWantedSkeleton;
